<template>
    <div class="form-error">
        <div v-for="error in errors">{{error}}</div>
    </div>
</template>

<script>

export default {
    name: "FormErrors",
    props: ['errors']
}
</script>
